import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Avatar, Card, Container, Grid, Grow, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { getUserInfo } from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    avatar: {
        width: theme.spacing(20),
        height: theme.spacing(20),
        border: "4px solid",
        borderColor: "#9c0404",
    },
}));

export default function Profile() {
    const classes = useStyles();
    const [userInfo, setUserInfo] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [turkce, setTurkce] = useState(false);
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    var base64Image = "";
    useEffect(() => {
        LocalLanguage();
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        let userCode = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
        dispatch(getUserInfo(userCode));
    }, []);

    const {
        user: { userInformation },
    } = useSelector((user) => user);

    useEffect(() => {
        if (userInformation?.resultObject) {
            const { resultObject } = userInformation;
            setUserInfo(resultObject);
            setPageLoaded(true);
        }
    }, [userInformation]);

    const LocalLanguage = () => {
        if (localStorage.getItem("i18nextLng") == "tr-TR") {
            setTurkce(true);
        }
    };

    if (userInfo?.profilePhoto) {
        base64Image = "data:image/png;base64," + userInfo?.profilePhoto;
    }

    return (
        <div>
            {pageLoaded ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <Container fixed justify="center" maxWidth="xs" style={{ marginTop: 20, marginBottom: 20 }}>
                        <Card>
                            <Grid container display="flex" justifyContent="center" style={{ padding: 20 }} spacing={2.5}>
                                <Grid item xs={12} style={{ width: "100%", paddingTop: 20, display: "flex", justifyContent: "center" }}>
                                    <Avatar alt="user" src={base64Image || <AccountCircle />} className={classes.avatar} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField label={t("NameSurname")} defaultValue={userInfo?.employeeName} InputProps={{ readOnly: true }} variant="outlined" style={{ width: "100%" }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField label={t("ID")} defaultValue={userInfo?.employeeCode} InputProps={{ readOnly: true }} variant="outlined" style={{ width: "100%" }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("Department")}
                                        defaultValue={turkce === true ? userInfo?.isletmeName || "" : userInfo?.isletmeNameEn || ""}
                                        InputProps={{ readOnly: true }}
                                        variant="outlined"
                                        style={{ width: "100%" }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t("Task")}
                                        defaultValue={turkce === true ? userInfo?.plansText : userInfo?.plansTextEn}
                                        InputProps={{ readOnly: true }}
                                        variant="outlined"
                                        style={{ width: "100%" }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField label={"MostID"} defaultValue={userInfo?.mostUserId} InputProps={{ readOnly: true }} variant="outlined" style={{ width: "100%" }} />
                                </Grid>
                            </Grid>
                        </Card>
                    </Container>
                </Grow>
            ) : null}
        </div>
    );
}
